import { createReducer } from '@reduxjs/toolkit'
import {
  addTrainingWorkout, combineTrainingWorkout, getTrainingWorkoutList, removeTrainingWorkoutFromGroup,
  resetModalAddTrainingWorkout,
  resetModalCombine,
  saveSetup,
  setReloadTrainingWorkout,
  setTrainingWorkout, setTrainingWorkoutType, showModalAddTrainingWorkout, seletectedTrainingWorkoutData,
  showModalCombine, updateSetupTrainingWorkout, updateTypeGroupTrainingWorkout,
  addSubstituteToParent, removeSubstituteFromParent, updateSubstituteSetupInState,
  showModalAddSubstitute, resetModalAddSubstitute
} from './training-workout.actions'
import { TrainingWorkoutFormattedProps, TrainingWorkoutTypeEnum } from '../../../components/TrainingWorkout'
import { TrainingWorkoutGroupInterface } from '../../../models/interfaces/training-workout-group.interface'

export interface ModalCombineData {
  items: string[]
}

export interface ModalCombineDataEdit {
  groupTrainingWorkout: TrainingWorkoutGroupInterface
}

export interface ModalAddTrainingWorkout {
  id: string
  parentTrainingWorkoutId?: string
  parentWorkoutId?: string
  existingSubstituteWorkoutIds?: string[]
}

interface TrainingWorkoutState {
  dataResult: TrainingWorkoutFormattedProps[]
  trainingWorkoutType: TrainingWorkoutTypeEnum | null
  reload: boolean
  modalCombineData: ModalCombineData | ModalCombineDataEdit | null
  modalCombineIsVisible: boolean
  modalAddTrainingWorkoutData: ModalAddTrainingWorkout | null
  modalAddTrainingWorkoutIsVisible: boolean
  seletectedTrainingWorkoutData: any
}

const initialState: TrainingWorkoutState = {
  dataResult: [],
  trainingWorkoutType: null,
  reload: false,
  modalCombineData: null,
  modalCombineIsVisible: false,
  modalAddTrainingWorkoutData: null,
  modalAddTrainingWorkoutIsVisible: false,
  seletectedTrainingWorkoutData: []
}

export const trainingWorkoutReducer = createReducer(initialState, builder => {
  builder.addCase(getTrainingWorkoutList.fulfilled, (state, action) => ({
    ...state,
    dataResult: action.payload.data
  }))
  builder.addCase(addTrainingWorkout.fulfilled, state => ({
    ...state,
    reload: !state.reload
  }))
  builder.addCase(removeTrainingWorkoutFromGroup.fulfilled, state => ({
    ...state,
    reload: !state.reload
  }))
  builder.addCase(updateSetupTrainingWorkout.fulfilled, state => ({
    ...state
  }))
  builder.addCase(combineTrainingWorkout.fulfilled, state => ({
    ...state,
    reload: !state.reload
  }))
  builder.addCase(updateTypeGroupTrainingWorkout.fulfilled, state => ({
    ...state,
    reload: !state.reload
  }))

  builder
    .addCase(setTrainingWorkout, (state, action) => {
      state.dataResult = action.payload
    })
    .addCase(seletectedTrainingWorkoutData, (state, action) => {
      state.seletectedTrainingWorkoutData = action.payload
    })
    .addCase(setTrainingWorkoutType, (state, action) => {
      state.trainingWorkoutType = action.payload
    })
    .addCase(setReloadTrainingWorkout, state => {
      state.reload = !state.reload
    })
    .addCase(saveSetup, (state, action) => {
      if (action.payload.isGrouped) {
        state.dataResult = state.dataResult.map(items => {
          items.data?.trainingsWorkouts?.map((item: any) => {
            if (action.payload.id === item.id) {
              item.setup = action.payload.setups
              return item
            }
            return item
          })
          return items
        })
        return state
      }
      state.dataResult = state.dataResult.map(item => {
        if (action.payload.id === item.id) {
          item.data.setup = action.payload.setups
          return item
        }
        return item
      })
    })
    .addCase(showModalCombine, (state, action) => {
      state.modalCombineData = action.payload
      state.modalCombineIsVisible = true
    })
    .addCase(resetModalCombine, state => {
      state.modalCombineData = null
      state.modalCombineIsVisible = false
    })
    .addCase(showModalAddTrainingWorkout, (state, action) => {
      state.modalAddTrainingWorkoutData = action.payload
      state.modalAddTrainingWorkoutIsVisible = true
    })
    .addCase(resetModalAddTrainingWorkout, state => {
      state.modalAddTrainingWorkoutData = null
      state.modalAddTrainingWorkoutIsVisible = false
    })
    .addCase(showModalAddSubstitute, (state, action) => {
      state.modalAddTrainingWorkoutData = action.payload
      state.modalAddTrainingWorkoutIsVisible = true
    })
    .addCase(resetModalAddSubstitute, state => {
      state.modalAddTrainingWorkoutData = null
      state.modalAddTrainingWorkoutIsVisible = false
    })
    .addCase(addSubstituteToParent, (state, action) => {
      state.dataResult = state.dataResult.map(item => {
        if (item.type === 'NORMAL' && item.id === action.payload.parentId) {
          return {
            ...item,
            data: {
              ...item.data,
              substitutes: [...(item.data.substitutes ?? []), action.payload.substitute]
            }
          }
        }
        if (item.type === 'GROUP' && item.data?.trainingsWorkouts?.some((tw: any) => tw.id === action.payload.parentId)) {
          return {
            ...item,
            data: {
              ...item.data,
              trainingsWorkouts: item.data.trainingsWorkouts.map((tw: any) => {
                if (tw.id !== action.payload.parentId) return tw
                return { ...tw, substitutes: [...(tw.substitutes ?? []), action.payload.substitute] }
              })
            }
          }
        }
        return item
      })
    })
    .addCase(removeSubstituteFromParent, (state, action) => {
      state.dataResult = state.dataResult.map(item => {
        if (item.type === 'NORMAL' && item.id === action.payload.parentId) {
          return {
            ...item,
            data: {
              ...item.data,
              substitutes: (item.data.substitutes ?? []).filter(
                (s: any) => s.id !== action.payload.substituteId
              )
            }
          }
        }
        if (item.type === 'GROUP' && item.data?.trainingsWorkouts?.some((tw: any) => tw.id === action.payload.parentId)) {
          return {
            ...item,
            data: {
              ...item.data,
              trainingsWorkouts: item.data.trainingsWorkouts.map((tw: any) => {
                if (tw.id !== action.payload.parentId) return tw
                return {
                  ...tw,
                  substitutes: (tw.substitutes ?? []).filter((s: any) => s.id !== action.payload.substituteId)
                }
              })
            }
          }
        }
        return item
      })
    })
    .addCase(updateSubstituteSetupInState, (state, action) => {
      state.dataResult = state.dataResult.map(item => {
        if (item.type === 'NORMAL' && item.id === action.payload.parentId) {
          return {
            ...item,
            data: {
              ...item.data,
              substitutes: (item.data.substitutes ?? []).map((s: any) => {
                if (s.id === action.payload.substituteId) {
                  return { ...s, setup: action.payload.setup }
                }
                return s
              })
            }
          }
        }
        if (item.type === 'GROUP' && item.data?.trainingsWorkouts?.some((tw: any) => tw.id === action.payload.parentId)) {
          return {
            ...item,
            data: {
              ...item.data,
              trainingsWorkouts: item.data.trainingsWorkouts.map((tw: any) => {
                if (tw.id !== action.payload.parentId) return tw
                return {
                  ...tw,
                  substitutes: (tw.substitutes ?? []).map((s: any) =>
                    s.id === action.payload.substituteId ? { ...s, setup: action.payload.setup } : s
                  )
                }
              })
            }
          }
        }
        return item
      })
    })
})
